import React from "react";

const SubscribedPlansCard = ({ plan, homeHandler, handlecenterId }) => {
  const getFullDate = (date) => {
    const startedDate = new Date(date);
    const dd = String(startedDate.getDate()).padStart(2, "0");
    const mm = String(startedDate.getMonth() + 1).padStart(2, "0");
    const yyyy = startedDate.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const isBefore = (date1) => {
    return date1 < new Date() ? true : false;
  };

  return (
    <div
      className={`subscribedPlansCard ${
        isBefore(plan.paymentExpiryDate) ? "subscribedPlansCard__expired" : ""
      }`}
    >
      <h5>{plan.centerId?.name}</h5>
      <p>Date : {getFullDate(plan.paymentDate)}</p>
      <p>Expiry date : {getFullDate(plan.paymentExpiryDate)}</p>
      <div>
        <p>
          Amount : {plan.paymentData?.currencySymbol} {plan.paymentData?.amount}
        </p>
        {isBefore(plan.paymentExpiryDate) && (
          <button
            onClick={() => {
              homeHandler();
              handlecenterId(plan.centerId?._id);

              requestAnimationFrame(() => {
                window.scrollTo({
                  top: document.body.scrollHeight,
                  behavior: "smooth",
                });
              });
            }}
          >
            Renew
          </button>
        )}
      </div>
      {plan.paymentType === "complimentary" && (
        <p>
          Type : {plan.paymentType === "complimentary" ? "Complimentary" : ""}
        </p>
      )}
    </div>
  );
};

export default SubscribedPlansCard;
